import BaseService from "./BaseService";

export class FootnotesService extends BaseService {
  static getAll() {
    return this.get("/cfadminsysmaintain/api/v1/footnotes");
  }

  static create(data: any) {
    return this.post("/cfadminsysmaintain/api/v1/footnotes", data);
  }

  static update(id: any, data: any) {
    return this.put("/cfadminsysmaintain/api/v1/footnotes", id, data);
  }

  static delete(id: any) {
    return super.delete("/cfadminsysmaintain/api/v1/footnotes", id);
  }
}

export default FootnotesService;